export const typography = {
    fontFamily: 'Inter, sans-serif',
    weights: {
        regular: 400,
        medium: 500,
        semiBold: 600,
        bold: 700,
    },
    sizes: {
        pageTitle: {
            fontSize: '2rem', // 32px
            lineHeight: '1.25',
            fontWeight: 700,
        },
        sectionTitle: {
            fontSize: '1.5rem', // 24px
            lineHeight: '1.33',
            fontWeight: 600,
        },
        body: {
            fontSize: '1rem', // 16px
            lineHeight: '1.5',
            fontWeight: 400,
        },
        small: {
            fontSize: '0.875rem', // 14px
            lineHeight: '1.43',
            fontWeight: 400,
        },
        label: {
            fontSize: '0.875rem', // 14px
            lineHeight: '1.43',
            fontWeight: 500,
        },
    },
};
